// Clean, human-free category images (no people/faces/skin) used as fallbacks
// so every category shows its OWN distinct image and never a human photo.
const B = "https://static.prod-images.emergentagent.com/jobs/0f0a4054-f73a-400c-ade1-acddbcf0f487/images";

export const CATEGORY_IMAGES = {
  clothing: `${B}/bfd1b0c11a1b79853bbe3e6d317b82fe7ae3bfc6bee2a9976f1009d2274aa051.jpeg`,
  boys: `${B}/bfd1b0c11a1b79853bbe3e6d317b82fe7ae3bfc6bee2a9976f1009d2274aa051.jpeg`,
  girls: `${B}/bfd1b0c11a1b79853bbe3e6d317b82fe7ae3bfc6bee2a9976f1009d2274aa051.jpeg`,
  teens: `${B}/bfd1b0c11a1b79853bbe3e6d317b82fe7ae3bfc6bee2a9976f1009d2274aa051.jpeg`,
  groceries: `${B}/708acff608ff0d4e14b690d942ff10578feb3a4a6adad906622c49613c29e3ce.jpeg`,
  food: `${B}/3104cabff5fc3c7d3d8edfa525e14a1391041f834ba4bcf56cefbb60a264d8d5.jpeg`,
  furniture: `${B}/b6979e5816686d3b4ba89b5bd139fe52b040ccb6a5cf0a11ebf4e77e46d59b9f.jpeg`,
  appliances: `${B}/f889c6998f0009d9787f117a4242b7b8d3dbf725b3fc987f707a90fe96ebadb5.jpeg`,
  electronics: `${B}/7e639e6e762e11e78636ff232e166d8b7387f1243267ede02821e26942046f37.jpeg`,
  baby: `${B}/92d232e31730be4f2d3712bc6f17ec264481a2153ccd9bdbcffa896fe495e581.jpeg`,
  housewares: `${B}/34741825ad3ec44051e19e07503de6dd27477f8e5510fa06bd5428b0735db742.jpeg`,
  judaica: `${B}/ccb85107b62c2745882ff2d366a2ed7c7e8783c8bf142051f0ef8f0ea7429774.jpeg`,
  gifts: `${B}/2596bda280661034a6fe3c4ad9db16899246ab391d1347e736366d1cb2dfd658.jpeg`,
  services: `${B}/47fd30b4ca523f598a6ed810ca7dca42e1e8372133c8ac6be29f15110385c555.jpeg`,
  cars: `${B}/ada67cc46f61f017756e3217f88b46a1112d194a55067caa957b99893d5ca7ee.jpeg`,
  toys: `${B}/5fd3afe0598f5b9a19c10fc6cd4f939b74bdf5d012df9b474fbaea14da8e94a9.jpeg`,
  health: `${B}/ad1a8266d0773bcfbeaab22a05bced2f092beb5240002e4172899f559b278c6b.jpeg`,
  sports: `${B}/77ca44cb570e7acf5cd7625a5db31b61607de0606dd42924af979498e7e2eb9a.jpeg`,
  mixed: `${B}/ec3f6fed1051ead3e1f4257beef343692785eeb25aa7ec61093f25fd30dc5f01.jpeg`,
};

// Returns the sale's own image, unless it's missing or a stock/human photo,
// in which case it returns the clean category-specific image.
export function categoryImage(sale) {
  const img = sale?.image || "";
  const isStock = /unsplash\.com|pexels\.com/i.test(img);
  if (img && !isStock) return img;
  const key = String(sale?.department || sale?.category || "mixed").toLowerCase();
  return CATEGORY_IMAGES[key] || CATEGORY_IMAGES.mixed;
}
